import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';

import types from './types';
import actions from './actions';
import mutations from './mutations';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const state = {
  isMobile: false,
  isUserGuide: false,
  isNoApplication: false,
  isCustomPopup: false,
  checkedBtnSource: '',
  isLoading: true,
  popupStep: 0,
  dacaGrantBtnText: '',
  dacaLoanBtnText: '',
  ifrpBtnText: '',
  ifrpLoanBtnText: '',
  mijaGrantBtnText: '',
  userInfo: {
    userId: '',
    firstName: '',
    lastName: '',
    email: '',
    yearOfBirth: '',
    isFirstTimeLoginNCA: false
  },
  contactInfo: {
    contactSources: [],
    isDACAGrantAvailable: false,
    isDACALoanAvailable: false,
    isIFRPAvailable: false,
    isIFRPLoanAvailable: false,
    isMIJAGrantAvailable: false,
  },
  currentTab: {
    label: 'Home',
    iconName: 'home',
    popupInfo: {
      iconName: 'popup-home',
      description: 'This is your homepage. In here you can find a summary of your pending applications and programs.',
      btnText: 'Next'
    }
  },
  showPhoneMenu: false,
  dashboardHomeData: {
    pendingApps: [],
    program: {
      activeProgram: {
        viewLoans: [],
        viewIFRPs: []
      },
      closedProgram: {
        viewLoans: [],
        viewIFRPs: []
      }
    }
  },
  showLoansPopup: {
    isShow: false,
    loanStatus: '',
  },
  timeOut: false,
};

const store = new Vuex.Store({
  state,
  actions,
  mutations,
  types,
  plugins: debug ? [createLogger()] : [],
  strict: debug,
});

window.VueStore = store;

export default store;
export { types };



// WEBPACK FOOTER //
// ./src/vuex/index.js